import React from "react"
import axios from 'axios'

import Layout from "../components/layout"
import SEO from "../components/seo"
import UploadBtn from '../components/uploadBtn'

export default class Jobbansokan extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      cv:'',
      brev:'',
      bild:'',
      namn:'',
      personnr:'',
      adress:'',
      mobilnr:'',
      nationalitet:'',
      alder:'',
      sending:false,
      sent:false,
      error:false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSenderClick = this.handleSenderClick.bind(this);
  }

  getFormData() {
    const dataKeys = ['cv','brev','bild','namn','personnr','adress','mobilnr','nationalitet','alder'];
    let data = {};
    dataKeys.forEach(key => {
      data[key] = this.state[key];
    });

    return data;
  }

  handleSenderClick() {

    this.setState({sent:false,sending:true});

        axios.get('https://datasets.recondex.se/thwjobb', {
          params: this.getFormData(),
        })
        .then(response => {
            const ok = response.data === 'ok';
            this.setState({sending:false,sent:ok,error:!ok });
        })
        .catch(error => {
            this.setState({sending:false,error:true,sent:false});
        });


    setTimeout(() => {
      this.setState({sent:true,sending:false});
    }, 3000);
  }

  handleInputChange(ev) {
    const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;

    this.setState({
      [ev.target.name]: value,
    });
  }

  render(){
    return(
      <Layout>
        <SEO title="Jobba hos oss" keywords={[`gatsby`, `application`, `react`]} />
        <div className="page">
          <div className="page-header">
            <h1>Jobbansökan</h1>
          </div>
          <div className="container tight text-outer">
            <form name="jobbansokan" action="/pages/tack" method="post">
              {!this.state.sent && !this.state.sending && !this.state.error && (
                <div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <input type="text" className="form-control mb-3" onChange={this.handleInputChange} value={this.state.namn} name="namn" placeholder="Namn" />
                    </div>
                    <div className="col-12 col-md-6">
                      <input min="0" maxlength="10" inputmode="numeric" pattern="[0-9]*" type="number" className="form-control mb-3" onChange={this.handleInputChange} value={this.state.personnr} name="personnr" placeholder="Personnr" />
                    </div>
                    <div className="col-12 col-md-6">
                      <input type="text" className="form-control mb-3" onChange={this.handleInputChange} value={this.state.adress} name="adress" placeholder="Adress" />
                    </div>
                    <div className="col-12 col-md-6">
                      <input type="tel" min="0" inputmode="numeric" pattern="[0-9]*" required="required" className="form-control mb-3" onChange={this.handleInputChange} value={this.state.mobilnr} name="mobilnr" placeholder="Mobilnr" />
                    </div>
                    <div className="col-12 col-md-6">
                      <input type="text" className="form-control mb-3" onChange={this.handleInputChange} value={this.state.nationalitet} name="nationalitet" placeholder="Nationalitet" />
                    </div>
                    <div className="col-12 col-md-6">
                      <input min="0" maxlength="10" inputmode="numeric" pattern="[0-9]*" type="number" className="form-control mb-3" onChange={this.handleInputChange} value={this.state.alder} name="alder" placeholder="Ålder" />
                    </div>
                    <div className="col-12 col-md-4">
                      <UploadBtn onChange={cv => this.setState({cv})} chooseFileLabel="Välj fil (cv)" changeFileLabel="Ändra fil (cv)" />
                    </div>
                    <div className="col-12 col-md-4">
                      <UploadBtn onChange={brev => this.setState({brev})} chooseFileLabel="Välj fil (personligt brev)" changeFileLabel="Ändra fil (personlig brev)" />
                    </div>
                    <div className="col-12 col-md-4">
                      <UploadBtn onChange={bild => this.setState({bild})} chooseFileLabel="Välj fil (bild)" changeFileLabel="Ändra fil (bild)" />
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-12 col-md-4 col-md-push-4">
                      <button type="button" onClick={this.handleSenderClick} className="btn btn-primary btn-block">Skicka</button>
                    </div>
                  </div>
                </div>
              )}
              {this.state.error && (
                <h3 className="text-center">Något gick fel! Vänligen försök igen senare..</h3>
              )}
              {this.state.sending && !this.state.error && (
                <h3 className="text-center">Skickar din data...</h3>
              )}
              {this.state.sent && !this.state.error && (
                <h3 className="text-center">Tack för din ansökan!</h3>
              )}
            </form>
          </div>
        </div>
      </Layout>
    );
  }
}
